export const detectUserAccess = (accessType, user) => {
  if (user) {
    return parseInt(user[accessType]) === 1;
  }

  return false;
};
